module.exports = __webpack_public_path__ + "img/Yoga-Logo_1_freigestellt.01b17f0e.svg";